import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import proj4 from 'proj4';
import OskariRPC from 'oskari-rpc';

import { mapKeys, EPSG3067, EPSG4326 } from '../config';
import OskariMapSearch from './map/OskariMapSearch.jsx';

const iframeSrc = `${mapKeys.OSKARI_ORIGIN}/hkp/published/fi/${mapKeys.OSKARI_KEY}`;
const startPosition = [439397, 7202810, 0];

class MapModal extends Component {
  constructor(props) {
    super();
    this.state = {
      address: ''
    };
  }

  onIframeLoaded = (iFrame) => {
    if (this.props.show) {
      this.channel = OskariRPC.connect(iFrame, mapKeys.OSKARI_ORIGIN);
      this.channel.onReady(() => {
        this.channel.postRequest('MapMoveRequest', startPosition);
        this.channel.handleEvent('MapClickedEvent', data => this.setMarkerToMap(data.lon, data.lat));
      });
    }
  }

  onButtonPress = () => {
    this.channel.destroy();
    this.props.disableLocationSelect();
  }

  setMarkerToMap(lon, lat) {
    const coordinates = proj4(EPSG3067, EPSG4326, [lon, lat]);
    this.props.handleChange('lon', coordinates[1]);
    this.props.handleChange('lat', coordinates[0]);
    this.channel.postRequest('MapModulePlugin.RemoveMarkersRequest', []);
    this.addMarker(lon, lat);
  }

  postRequestToChannel = (requestType, data) => {
    if (requestType === 'MapMoveRequest') {
      this.setMarkerToMap(data[0], data[1]);
    }
    this.channel.postRequest(requestType, data);
  }

  addMarker = (lon, lat) => {
    const markerOptions = {
      x: lon,
      y: lat,
      color: 'ff0000',
      msg: '',
      shape: 2,
      size: 3
    };
    this.channel.postRequest('MapModulePlugin.AddMarkerRequest', [markerOptions]);
  }

  addEventHandler = (eventType, eventHandler) => {
    this.channel.onReady(() => this.channel.handleEvent(eventType, eventHandler));
  }

  render() {
    return (
      <Modal show={this.props.show} className="inmodal">
        <Modal.Body>
          <p>
            Valitse harjoituksen sijainti kartalta tai hae sijaintia kohteen osoitteella tai paikannimellä.
            Sijainniksi tulisi antaa harjoituksen järjestyspaikka tai vastaava.
            Harjoituksen laajuus annetaan seuraavassa kohdassa. Tallenna harjoituksen sijainti jatkaaksesi.
          </p>

          <ButtonToolbar>
            <Button onClick={this.onButtonPress}>Tallenna sijainti</Button>
          </ButtonToolbar>

          <br />

          <div className="map-wrapper">
            <OskariMapSearch channelRequest={this.postRequestToChannel} addEventHandler={this.addEventHandler} />
            <iframe ref={this.onIframeLoaded} id="oskari-map" src={iframeSrc} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

MapModal.propTypes = {
  disableLocationSelect: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default MapModal;



// WEBPACK FOOTER //
// ./src/components/MapModal.jsx